"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FontColourPicker = void 0;
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var FilterableColorProvider_1 = require("Project/QwilrEditor/Styling/FilterableColorProvider");
var ColorSwatch_1 = require("Common/ColorSwatch/ColorSwatch");
var ColorPalette_1 = __importDefault(require("Common/ColorPalette/ColorPalette"));
var GetBlockStyle_1 = require("@CommonFrontendBackend/StyleServiceV2/GetBlockStyle");
var FontColourPicker = function (_a) {
    var currentColour = _a.currentColour, tooltipContent = _a.tooltipContent, onColorChange = _a.onColorChange;
    var colorProvider = (0, FilterableColorProvider_1.useFilterableColorProvider)();
    return (react_1.default.createElement(kaleidoscope_1.Popover, { className: "nested-portal", autoStack: true, size: kaleidoscope_1.PopoverSize.Small, button: function (buttonProps) { return (react_1.default.createElement(kaleidoscope_1.IconButton, __assign({}, buttonProps, { icon: react_1.default.createElement(ColorSwatch_1.ColorSwatch, { background: currentColour.abs, size: "large" }), tooltip: !!tooltipContent ? { content: tooltipContent } : undefined }))); } },
        react_1.default.createElement(ColorPalette_1.default, { theme: "light", onColorChange: function (newColour) { return onColorChange((0, GetBlockStyle_1.convertColorToColorObj)(newColour)); }, selectedColor: (0, GetBlockStyle_1.convertColorObjToColor)(currentColour), presetColors: colorProvider.filteredThemeColors, includeColorPanelPicker: true, type: "block" })));
};
exports.FontColourPicker = FontColourPicker;
